export var EXPRESS_KEYS = "\n  query ExpressKeys {\n    expressKeys {\n      channelName\n      traceId\n      appKey\n      cluster\n    }\n  }\n";